module.exports = __webpack_public_path__ + "img/jjptadmin-qrcode.a83e80d0.png";